import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { deleteService } from 'api/Service';

import { useTableContext } from 'lib/context/TableContext/TableContext';

import { showAlert } from 'components/shared/Alert/Alert';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

const ServiceActions = (params) => {
  const { data } = params;
  const { setSelectedItem, setShowModal } = useTableContext();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const navigate = useNavigate();
  const { id: practiceId } = useParams();
  const queryClient = useQueryClient();

  const handleRemove = async () => {
    const onSuccess = () => {
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'services',
        refetchType: 'all'
      });

      showAlert({
        title: 'Service removal',
        message: 'Service removed successfully',
        color: 'success'
      });

      setShowDeleteModal(false);
    };

    const onError = () => {
      showAlert({
        title: 'Service removal failed',
        message: 'Something went wrong deleting the service',
        color: 'danger'
      });
    };

    await deleteService(
      navigate,
      { serviceId: data.id, practiceId: Number(practiceId) },
      { onError, onSuccess }
    );
  };

  const options = [
    {
      label: 'Edit',
      onClick: () => {
        setSelectedItem(data);
        setShowModal(true);
      },
      icon: 'edit-2-mono'
    },
    {
      label: 'Remove',
      onClick: () => setShowDeleteModal(true),
      icon: 'trash-mono'
    }
  ];

  return (
    <div className="flex h-full items-center justify-center">
      <Popover
        isFixed
        options={options}
        position="left"
        icon="context-menu-horizontal"
        className="flex flex-1 justify-center self-center"
      />
      {showDeleteModal && (
        <Confirm
          variant="danger"
          title="Remove Service"
          icon="trash-mono"
          message="Are you sure you want to remove this service?"
          handleOpen={showDeleteModal}
          handleClose={() => setShowDeleteModal(false)}
          footerActions={{
            primary: {
              text: 'Yes, remove',
              onClick: handleRemove,
              color: 'danger'
            }
          }}
        />
      )}
    </div>
  );
};

export default ServiceActions;
